var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService } from '../../../../../services/modules/brand-client.service';
import * as Enumerable from 'linq';
import { NotificationClientService, NotificationType } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
var ManageSweepstakesDialog = /** @class */ (function () {
    function ManageSweepstakesDialog(dialogClient, brandClientService, notificationService, i18N) {
        this.dialogClient = dialogClient;
        this.brandClientService = brandClientService;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.operatorInstantGamesPricingModels = [];
        this.isDataLoading = false;
        this.disableButtons = false;
        this.configs = [];
    }
    ManageSweepstakesDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    ManageSweepstakesDialog.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.disableButtons = true;
                        // save only subscribed sweepstakes in brand sweepstake and lotterypricingmodel table
                        return [4 /*yield*/, this.brandClientService
                                .manageBrandSweepstakeSubscriptions('brandId' in this.vm.item ? this.vm.item.brandId : null, this.vm.item.operatorId, this.configs)
                                .then(function (response) {
                                _this.notificationService.show(_this.i18N.tr('manage-sweepstakes'), _this.i18N.tr('manage-successfully-added-sweepstakes'), NotificationType.Success);
                                _this.vm.reLoad(_this.vm.item);
                                _this.dialogClient.hide();
                            }, function (e) {
                                _this.notificationService.show(_this.i18N.tr('manage-sweepstakes'), _this.i18N.tr('manage-failed-adding-sweepstakes'), NotificationType.Error);
                            })];
                    case 1:
                        // save only subscribed sweepstakes in brand sweepstake and lotterypricingmodel table
                        _a.sent();
                        this.disableButtons = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ManageSweepstakesDialog.prototype, "sweepstakes", {
        get: function () {
            var _this = this;
            if (!this.search)
                return this.configs;
            var enumerable = Enumerable.from(this.configs);
            if (this.search)
                enumerable = enumerable.where(function (x) { return x.sweepstakeName.toLowerCase().indexOf(_this.search.toLowerCase()) >= 0; });
            return enumerable.toArray();
        },
        enumerable: false,
        configurable: true
    });
    ManageSweepstakesDialog.prototype.activate = function (model) {
        var _this = this;
        if (!model)
            return;
        this.vm = model;
        this.isDataLoading = true;
        //the below will always be true though needed for typescript 
        if ('brandId' in this.vm.item) {
            this.brandClientService
                .getSweepstakeBrandSubsciptions(this.vm.item.brandId, this.vm.item.operatorId)
                .then(function (x) {
                _this.isDataLoading = false;
                _this.configs = Enumerable.from(x.configs).orderBy(function (x) { return x.sweepstakeName; }).toArray();
            }).catch(function (x) { return _this.isDataLoading = true; });
        }
    };
    ManageSweepstakesDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService,
            BrandClientService,
            NotificationClientService,
            I18N])
    ], ManageSweepstakesDialog);
    return ManageSweepstakesDialog;
}());
export { ManageSweepstakesDialog };
